// setShouldDisplayCleanModeHint.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should display clean mode hint
 * @kind action
 * @param {boolean} shouldDisplayCleanModeHint - If true, the clean mode hint will be shown; otherwise, it will be hidden.
 * @return {Promise} Action promise.
 */
const setShouldDisplayCleanModeHint =
  ({ shouldDisplayCleanModeHint }) =>
  async dispatch =>
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          shouldDisplayCleanModeHint,
        },
      },
    });
export default setShouldDisplayCleanModeHint;
